import { createRoute } from '@tanstack/react-router';

import { clientRoute } from '../route';

export const clientProductsRoute = createRoute({
	path: '/products',
	getParentRoute: () => clientRoute,
});
